import styled from "styled-components";

export const Page = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 15px;
    gap: 16px;

    @media (max-width: 574px) {
        padding: 12px;
    }
`;
